import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResearchAssistantService } from '../../services/research-assistant.service';

@Component({
  selector: 'app-research-dialog',
  templateUrl: './research-dialog.component.html',
  styleUrls: ['./research-dialog.component.scss']
})
export class ResearchDialogComponent {
  userPrompt = '';

  constructor(
    public dialogRef: MatDialogRef<ResearchDialogComponent>,
    // TODO: Add Type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) public data: any,
    private researchAssistantService: ResearchAssistantService
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  submitJob() {
    const documents = this.data.filteredData;
    const collection = this.data.collection.name ?? 'Name Not Found';
    this.researchAssistantService.launchJob(this.userPrompt, collection, documents).subscribe({
      next: response => {
        console.log('Job launched successfully:', response);
        this.dialogRef.close();
      },
      error: err => {
        console.error('Error launching job:', err);
      }
    });
  }
}
